import { apiClient } from "../config";

const SEND_PURCHASE_RECEIPT_TIMEOUT_MS = 60_000;

export type PurchaseReceiptStatus = "pending" | "sending" | "sent" | "failed";

export type PurchaseReceiptOrderStatus = {
  status: PurchaseReceiptStatus | null;
  sentAt: string | null;
  receiptOrderId?: string | null;
};

export type SendPurchaseReceiptResult =
  | {
      mode: "recorded";
      message: string;
      to: string;
      status: PurchaseReceiptStatus;
      lastError: string | null;
      sentAt: string | null;
    }
  | {
      mode: "preview";
      message: string;
      to: string;
      chargeKey: string;
    };

export const purchaseReceiptsService = {
  getForOrder: async (orderId: string): Promise<PurchaseReceiptOrderStatus> => {
    const response = await apiClient.get<PurchaseReceiptOrderStatus>(
      `/admin/purchase-receipts/orders/${orderId}`,
    );
    return response.data;
  },

  sendForOrder: async (
    orderId: string,
    options: { to?: string } = {},
  ): Promise<SendPurchaseReceiptResult> => {
    const response = await apiClient.post<SendPurchaseReceiptResult>(
      `/admin/purchase-receipts/orders/${orderId}/send`,
      options.to ? { to: options.to } : {},
      { timeout: SEND_PURCHASE_RECEIPT_TIMEOUT_MS },
    );
    return response.data;
  },
};
